<template>
  <div class="item selectable-shop-item">
    <div class="image">
      <div class="ui bottom right attached green label">{{ shop.area_detail_label }}</div>
      <img :src="shop.main_image.urls.medium_square" style="margin-bottom: 0 !important;">
    </div>
    <div class="content">
      <a class="header" :href="shop.shop_preview_url" target="_blank">
        <div v-if="shop.is_promotion" class="ui mini red label">上位PR</div>
        <div class="ui mini label" :class="rankLabelClass(shop.rank)">{{ shop.rank_label }}</div>
        <span>{{ shop.name }}</span>
      </a>
      <div class="meta">
        <p>店舗電話番号：{{ shop.tel }}</p>
        <p v-show="shop.shop_type">会場：{{ shop.shop_type_label }}</p>
        <p>
          最大宴会人数：
          <span v-show="shop.max_count > 0">着席：〜{{ shop.max_count }}人</span>
          <span v-show="shop.max_standing_count > 0">立席：〜{{ shop.max_standing_count }}人</span>
        </p>
        <p v-show="shop.courses.length > 0">プラン：{{ lowestPriceLabel(shop.courses) }}</p>
        <p v-show="shop.genres.length > 0">
          <span v-for="genre in shop.genre_labels" :key="genre" class="ui tiny label">{{ genre }}</span>
        </p>
      </div>
      <div class="extra">
        <div v-if="candidate" class="ui orange tiny button" @click="showCandidateDetail()">立候補内容を確認</div>
        <div v-if="!isSelected(shop)" class="ui green basic tiny button" @click="select()">選択する</div>
        <div v-else class="ui red tiny button" @click="unselect()">選択を解除する</div>
        <div class="ui left pointing red basic label" v-if="isSuggested()">提案済み</div>
      </div>
    </div>
    <div v-if="candidate" :id="dialogId" class="ui small modal">
      <i class="close icon"></i>
      <div class="header">{{ candidate.shop.name }}</div>
      <div class="scrolling content">
        <candidate-detail :candidate="candidate"></candidate-detail>
      </div>
      <div class="actions">
        <button class="ui cancel button">閉じる</button>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import candidateDetail from './../../components/candidateDetail.vue';

export default {
    components: {
        candidateDetail: candidateDetail
    },
    props: {
        shop: {
            required: true,
            type: Object,
        },
        suggestions: {
            required: true,
            type: Array,
        },
        marunage: {
            required: true,
            type: Object
        },
        candidate: {
            required: false,
        }
    },
    data: function() {
        return {
        };
    },
    methods: {
        lowestPriceLabel: function(courses) {
            if (courses.length === 0) {
                return '';
            }
            var lowestPriceCourse = _.sortBy(courses, function(course) {
                return course.discounted_price || course.price;
            })[0];
            var label = '';
            if (lowestPriceCourse.drink_type_label) {
                label = lowestPriceCourse.drink_type_label;
            } else {
                label = '飲み放題なし';
            }
            label += ' ' + (lowestPriceCourse.discounted_price || lowestPriceCourse.price) + '円〜';
            return label;
        },
        rankLabelClass: function(rank) {
            return {
                'A': 'teal',
                'B': 'olive',
                'C': 'brown',
                'D': 'grey',
            }[rank];
        },
        select: function() {
            this.suggestions.push(this.shop);
        },
        unselect: function() {
            var i = _.findIndex(this.suggestions, function(each) {
                return each.id === this.shop.id;
            }.bind(this));
            if (i != -1) {
                this.suggestions.splice(i, 1);
            }
        },
        isSelected: function() {
            return _.includes(_.map(this.suggestions, function(each) {
                return each.id;
            }), this.shop.id);
        },
        isSuggested: function() {
            return _.includes(_.map(this.marunage.marunage_shops, function(each) {
                return each.shop.id;
            }), this.shop.id);
        },
        showCandidateDetail: function() {
            $('#' + this.dialogId).modal('show');
        }
    },
    computed: {
        dialogId: function() {
            return 'candidate-dialog-' + this.candidate.id;
        }
    }
};
</script>
